import React from 'react';

const WorkflowIcon = ({ className = '', size = 100 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 92"
      width={size}
      height={(size * 92) / 100}
      preserveAspectRatio="xMidYMid meet"
      className={className}
      fill="currentColor"
    >
      <g
        transform="translate(0.000000,92.000000) scale(0.100000,-0.100000)"
        stroke="none"
      >
        <path d="M253 750 c-12 -5 -26 -18 -32 -29 -17 -31 -13 -106 7 -130 15 -19 25 -22 82 -19 62 3 66 4 80 35 l15 33 187 0 c215 0 208 3 208 -94 0 -60 -16 -86 -53 -86 -16 0 -18 3 -9 12 16 16 15 48 -1 48 -7 0 -31 -18 -52 -40 l-39 -40 42 -42 c33 -34 44 -40 54 -30 10 10 10 17 0 32 -11 18 -10 20 18 20 19 0 40 9 55 25 22 22 25 32 25 105 0 73 -3 83 -25 105 -24 25 -25 25 -220 25 -186 0 -195 1 -195 19 0 46 -86 76 -147 51z m102 -90 l0 -45 -47 -3 c-44 -3 -48 -1 -54 22 -3 15 -3 37 0 52 6 23 10 25 54 22 l47 -3 0 -45z" />
        <path d="M472 529 c-13 -5 -29 -22 -35 -39 l-11 -30 -84 0 c-75 0 -85 -2 -107 -25 -22 -22 -25 -32 -25 -105 0 -73 3 -83 25 -105 23 -24 29 -25 161 -25 135 0 137 0 120 -19 -19 -21 -14 -41 8 -41 8 0 30 18 51 41 l37 41 -38 39 c-21 21 -44 39 -50 39 -22 0 -26 -21 -8 -41 17 -19 15 -19 -107 -19 -68 0 -131 4 -138 9 -10 6 -16 32 -19 74 -6 86 6 97 101 97 71 0 72 -1 87 -33 14 -31 18 -32 80 -35 82 -4 100 13 100 93 0 46 -4 57 -26 74 -28 22 -82 27 -122 10z m103 -89 l0 -45 -47 -3 c-44 -3 -48 -1 -54 22 -3 15 -3 37 0 52 6 23 10 25 54 22 l47 -3 0 -45z" />
        <path d="M693 310 c-12 -5 -26 -18 -32 -29 -16 -29 -13 -103 5 -129 13 -19 24 -22 79 -22 78 0 95 17 95 96 0 45 -4 56 -26 73 -28 22 -82 27 -121 11z m102 -90 l0 -45 -47 -3 c-44 -3 -48 -1 -54 22 -3 15 -3 37 0 52 6 23 10 25 54 22 l47 -3 0 -45z" />
      </g>
    </svg>
  );
};

export {
  WorkflowIcon
};